import { combineEpics } from 'redux-observable'
import facebookEpics from './facebook'
import googleEpics from './google'
import fetchAnalyticsAndConsentEpic from './fetchAnalyticsAndConsent'
import initEpic from './init'
import mixPanelEpics from './mixPanel'
import oneTrustQueryURLEpic from './oneTrustQueryURL'

export default combineEpics(
  oneTrustQueryURLEpic,
  fetchAnalyticsAndConsentEpic,
  initEpic,
  facebookEpics,
  googleEpics,
  mixPanelEpics
)
